<template>
  <v-dialog width="500" v-model="dialog">
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex>
            <div>Create Schedule</div>
          </v-flex>
          <v-flex text-right>
            <v-btn @click="cancel" icon>
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="mx-10" v-if="dayTimeSchedule.length === 0">
        <v-flex text-center>
          <div class="body-2 grey--text text--darken-2">
            Click the + icon to add a day and time to the schedule
          </div>
        </v-flex>
      </v-layout>

      <v-layout class="mx-4">
        <v-flex>
          <!-- {{ schedule }} -->
          <v-layout v-if="dayTimeSchedule.length > 0">
            <v-flex xs6>
              <div class="mr-1 subtitle-2">Day</div>
            </v-flex>
            <v-flex xs6>
              <div class="ml-1 subtitle-2">Time</div>
            </v-flex>
          </v-layout>
          <template v-for="(item, i) in schedule">
            <schedule-item
              @deleteDayTime="deleteDayTime"
              @changeDayTime="changeDayTime"
              :key="`item-${i}`"
              :index="i"
              :details="item"
            />
          </template>
          <v-layout class="mt-3">
            <v-flex text-center>
              <v-btn
                dark
                color="primary"
                fab
                icon
                small
                elevation="2"
                @click="addDayTime"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ScheduleItem from "./ScheduleItem";
import moment from "moment";
export default {
  components: {
    ScheduleItem,
  },
  props: {
    dayTimeSchedule: {
      type: Array,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      schedule: [],
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      dialog: false,
    };
  },
  methods: {
    iMoment(timestamp) {
      if (timestamp) {
        let temp = timestamp.seconds * 1000;
        return moment(temp).format("lll");
      } else {
        return 0;
      }
    },
    addDayTime() {
      this.schedule.push({
        index: 0,
        day: "Sunday",
        time: "00:00",
      });
    },
    changeDayTime(object) {
      this.schedule.splice(object.index, 1, object.value);
    },
    cancel() {
      this.schedule = [];
      this.dialog = false;
    },
    deleteDayTime(object) {
      this.schedule.splice(object.index, 1);
    },
    save() {
      var object = {};
      this.schedule.forEach((item) => {
        object[item.index] = item.time;
      });
      console.log(object);
      console.log("Schedule: ", this.schedule);
      //   this.$emit("updateSchedule", object);
      this.$emit("updateSchedule", this.schedule);
      this.cancel();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
      if (this.dialog) {
        this.schedule = this.dayTimeSchedule;
      }
    },
  },
};
</script>

<style>
</style>